import DialogFriendsChallenge from '~/components/dialog/friends/DialogFriendsChallenge.vue';

export const useDialogFriendsChallenge = () => {
  const completeEvent = createEventHook<any>();

  const dialog = useDialogStore();

  const open = () => {
    dialog.open(DialogFriendsChallenge, {
      level: DialogLevel.Info,
      onClose: () => {
        completeEvent.trigger();
        dialog.close();
      },
    });
  };

  return {
    open,
    onComplete: completeEvent.on,
  };
};
